import React, { useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { ThemeContext } from "constants/themeContext";
import { THEME, calculatorColor } from "constants/index";
import auth from "auth";

function AppTheme({ children }) {
  let userInfo = auth.getUserInfo();
  let theme = userInfo.theme;
  let permission = userInfo.permission?.map((m) => m.codename) ?? [];
  let themeName = theme?.theme ?? "";
  let userTheme = THEME.find((f) => f.NAME === themeName);
  if (!userTheme || themeName === "Custom") {
    userTheme = THEME[0];
  }
  const [currentTheme, setTheme] = useState(userTheme);
  const [currentPermission, setPermission] = useState(permission);
  const [hideTop, setHideTop] = useState(false);
  const [userProfile, setUserProfile] = useState(userInfo);
  useEffect(() => {
    if (themeName === "Custom") {
      const custom = THEME.find((f) => f.NAME === "Custom");
      let obj = Object.assign({}, custom);
      let themeColor = calculatorColor(theme.color1, theme.color2, obj);
      setTheme(themeColor);
    }
  }, []);
  return (
    <ThemeContext.Provider
      value={{
        theme: currentTheme,
        setTheme,
        permission: currentPermission,
        setPermission,
        hideTop,
        setHideTop,
        userProfile,
        setUserProfile,
      }}
    >
      <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default AppTheme;
